import React, { useEffect, useState } from 'react';
import { Modal, Descriptions, Spin } from 'antd';
import api from '../../../../utils/api';

export default function CompanyDetailModal({ visible, companyId, onCancel }) {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && companyId) {
      setLoading(true);
      api.get(`/companies/${companyId}`).then(res => {
        if (res && res.code === 200) {
          setCompany(res.data);
        }
      }).finally(() => setLoading(false));
    } else {
      setCompany(null);
    }
  }, [visible, companyId]);

  return (
    <Modal
      title="企业详情"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      {loading ? <Spin /> : company ? (
        <Descriptions bordered column={1}>
          <Descriptions.Item label="中文名">{company.nameCn}</Descriptions.Item>
          <Descriptions.Item label="英文名">{company.nameEn}</Descriptions.Item>
          <Descriptions.Item label="简称">{company.alias}</Descriptions.Item>
          <Descriptions.Item label="统一社会信用代码">{company.licenseNumber}</Descriptions.Item>
          <Descriptions.Item label="注册资本">{company.capital} {company.capitalCurrency}</Descriptions.Item>
          <Descriptions.Item label="地址">{company.address_}</Descriptions.Item>
          <Descriptions.Item label="是否离岸">{company.offshore ? '是' : '否'}</Descriptions.Item>
        </Descriptions>
      ) : '暂无数据'}
    </Modal>
  );
}
